<template>
    <div
        class="w-full grid grid-cols-5 items-center justify-between text-slate-800"
        :class="{
            'opacity-60 cursor-not-allowed': props.disabled
        }"
    >
        <div class="col-span-4 grid items-center grid-cols-1 lg:grid-cols-3 gap-2">
            <div class="flex flex-col gap-1">
               <div v-if="!onCorporate() && props.segment.is_template" class="flex gap-1">
                    <font-awesome-icon widthAuto :icon="faCrown" class="text-sm text-amber-400"></font-awesome-icon>
                    <span class="text-xs text-slate-700">
                        Corporate Segment
                    </span>
                </div>
                <div class="flex items-center gap-2">
                    <span class="line-clamp-3" :title="props.segment.name">
                        {{ props.segment.name }}
                    </span>
                    <segment-description-popover :modelValue="props.segment"></segment-description-popover>
                </div>
            </div>

            <div v-if="currentGroup?.group_id">
                <div class="flex items-center gap-2">
                    {{ props.segment.preferred_group ? 'Preferred' : 'All' }}
                </div>
            </div>

            <div v-if="onCorporate()">
                <font-awesome-icon widthAuto
                    :icon="props.segment.type === SegmentType.STATIC ? faMapPin : faLoader"
                    class="text-slate-500 mr-1"
                ></font-awesome-icon>
                {{ formatSegmentType(props.segment.type) }}
            </div>
            <div data-test="segment-row-contact-count">
                <template v-if="props.contactsCount !== null && props.contactsCount !== undefined">
                    <font-awesome-icon widthAuto
                        :icon="faUser"
                        class="mr-1 text-slate-500 lg:hidden"
                    >
                    </font-awesome-icon>
                    {{ formatCount(props.contactsCount) }}
                </template>
                <font-awesome-icon widthAuto v-else :icon="faSpinnerThird" spin>
                </font-awesome-icon>
            </div>
        </div>
        <div class="text-right">
            <vx-button
                v-if="props.selected"
                type="button"
                color="muted"
                size="xs"
                :disabled="props.disabled"

            >
                Remove
            </vx-button>
            <vx-button
                v-else
                type="button"
                color="muted"
                size="xs"
                :disabled="props.disabled"
            >
                Add
                <font-awesome-icon widthAuto
                    class="text-xs ml-1"
                    :icon="faCirclePlus"
                ></font-awesome-icon>
            </vx-button>
        </div>
    </div>
</template>

<script setup>
import { VxButton } from '@voxie/frontend-components';
import { SegmentType, SegmentTypeToLabel } from '../../../constants/segment';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faCirclePlus,
    faMapPin,
    faUser,
    faCrown,
} from "@fortawesome/pro-solid-svg-icons";
import { faLoader, faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { useCurrentGroup } from '~/composables/useCurrentGroup';
import SegmentDescriptionPopover from '~/components/contacts/segments/SegmentDescriptionPopover.vue';

const props = defineProps({
    segment: {
        type: Object,
        required: true,
    },
    contactsCount: {
        type: Number,
        required: false,
    },
    selected: {
        type: Boolean,
        required: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    }
});

const { onCorporate, currentGroup } = useCurrentGroup();

const formatCount = (number) => {
    return number < 1000 ? Intl.NumberFormat('en').format(number) : Intl.NumberFormat('en', { notation: 'compact', minimumSignificantDigits: 3, maximumSignificantDigits: 3 }).format(number);
}
const formatSegmentType = (type) => {
    return SegmentTypeToLabel[type];
}

</script>
